(function($) {
  $('.banner-slider').slick({
    fade: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
  });
  $('.product-slider').slick({
    autoplay: true,
    arrows: true,
    dots: false,
    speed: 300,
  });
  $('.equipment-slider').slick({
    autoplay: true,
    arrows: false,
    dots: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          infinite: false,
        }
      },
    ],
  });
})($);